// Masifi: es/en only (2026-06-16, config/initializers/masifi/masifi_languages.rb); withMasifi = overlay + runtime brand.
import { withMasifi } from 'shared/i18n/masifi/masifiOverlay';
import masifiOverlay from './masifi';
import en from './locale/en';
import es from './locale/es';

export default withMasifi({ en, es }, masifiOverlay);
